import { reportEvent } from "@/api";
import { getStatus } from "@/libs/Status";
const Status = getStatus();

document.addEventListener("click", function (event) {
  const target = (event.target as HTMLElement).closest(
    "[data-lc-track]:not([disabled]):not(.disabled)"
  );
  if (target) {
    const trackValue = target.getAttribute("data-lc-track");
    if (trackValue) {
      if (Status.get("logged")) {
        reportEvent({
          event: "click",
          target: trackValue as any,
        });
      }
    }
  }
},true);
